export enum EquipmentStatusCategory {
  OPERATIONAL = 'OPERATIONAL',
  OPERATIONAL_WITH_RESTRICTIONS = 'OPERATIONAL_WITH_RESTRICTIONS',
  NOT_OPERATIONAL = 'NOT_OPERATIONAL',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}
